import React from 'react';
import { FiUser, FiCalendar, FiTrendingUp, FiPercent, FiActivity } from 'react-icons/fi';

const SummaryCards = ({ summaryStats }) => {
  if (!summaryStats || summaryStats.totalGames === 0) return null;

  return (
    <div className="summary-cards">
      <div className="summary-card">
        <div className="summary-icon">
          <FiUser size={24} />
        </div>
        <div className="summary-content">
          <div className="summary-label">Total Players</div>
          <div className="summary-value">{summaryStats.totalPlayers}</div>
        </div>
      </div>
      <div className="summary-card">
        <div className="summary-icon">
          <FiCalendar size={24} />
        </div>
        <div className="summary-content">
          <div className="summary-label">Total Games</div>
          <div className="summary-value">{summaryStats.totalGames}</div>
        </div>
      </div>
      {summaryStats.topKD && (
        <div className="summary-card">
          <div className="summary-icon">
            <FiTrendingUp size={24} />
          </div>
          <div className="summary-content">
            <div className="summary-label">Top K/D</div>
            <div className="summary-value">{summaryStats.topKD.Player}: {summaryStats.topKD.KD.toFixed(2)}</div>
          </div>
        </div>
      )}
      <div className="summary-card">
        <div className="summary-icon">
          <FiPercent size={24} />
        </div>
        <div className="summary-content">
          <div className="summary-label">Team Win Rate</div>
          <div className="summary-value">{Math.round(Number(summaryStats.teamWinRate || 0))}%</div>
        </div>
      </div>
      <div className="summary-card">
        <div className="summary-icon">
          <FiActivity size={24} />
        </div>
        <div className="summary-content">
          <div className="summary-label">Avg Score Diff</div>
          <div className="summary-value">
            {Number(summaryStats.avgScoreDiff || 0) >= 0 ? '+' : ''}
            {Number(summaryStats.avgScoreDiff || 0).toFixed(1)}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SummaryCards;

